/*
 * @Author: stingyxin 894739825@qq.com
 * @Date: 2023-05-24 15:32:00
 * @LastEditors: stingyxin 894739825@qq.com
 * @LastEditTime: 2023-06-21 11:23:58
 * @FilePath: \testgamehall\assets\script\webSDK\facebook\FbEvent.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 数数 打点统计
 * 更多接口参照《ThinkingAnalyticsAPI》类 ,外部不能直接调用,
 * 必须通过ThinkingEvent._ta 调用
 */

import { currentChannel } from "@/config/config";

export namespace KwaiqEvent {
    /**获得快手事件 */
    function getKwaiqEvent() {
        return (window as any).kwaiq;
    }

    /**
     * 上报事件
     * @param eventName 事件名称
     * @param agrs 事件参数
     * @returns 
     */
    function track(eventName: string, agrs?: any) {
        let _kwaiqEvent = getKwaiqEvent();
        if(!_kwaiqEvent || !_kwaiqEvent.ccKwaiqId){
            return;
        }
        console.log("eventName:", eventName, ",ccKwaiqId:", _kwaiqEvent.ccKwaiqId);
        if(agrs){
            _kwaiqEvent.instance(_kwaiqEvent.ccKwaiqId).track(eventName, agrs);
        }else{
            _kwaiqEvent.instance(_kwaiqEvent.ccKwaiqId).track(eventName);
        }
    }

    /**注册事件 */
    export function EventRegistr() {
        track('completeRegistration');
    }

    /***查看内容事件 */
    export function EventContentView() {
        track('contentView');
    }

    /**充值事件 */
    export function EventDoCharge(goldNum: number) {
        let args = {
            value: goldNum,
            currency: currentChannel.currency
        };
        track('purchase', args);
    }

    /**首充事件 */
    export function EventFirstCharge(goldNum: number) {
        let args = {
            value: goldNum,
            currency: currentChannel.currency
        };
        track('firstDeposit', args);
    }

    /**加购事件 */
    export function EventDoAddToCart(goldNum: number) {
        
        let args = {
            value: goldNum,
            currency: currentChannel.currency
        };
        track('addToCart', args);
    }

    /**是否有快手像素事件 */
    export function isHaveKwEvent(): boolean {
        let _kwaiqEvent = getKwaiqEvent();
        if(!_kwaiqEvent || !_kwaiqEvent.ccKwaiqId){
            return false;
        }
        return true;
    }
}
